import { render, staticRenderFns } from "./restoreOrderAlert.vue?vue&type=template&id=03b8a940&scoped=true"
import script from "./restoreOrderAlert.vue?vue&type=script&lang=js"
export * from "./restoreOrderAlert.vue?vue&type=script&lang=js"
import style0 from "./restoreOrderAlert.vue?vue&type=style&index=0&id=03b8a940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8a940",
  null
  
)

export default component.exports